import { MessageType } from './message-type';
import { SnackbarVariant } from '@eas/common-web';

const ACCESS: MessageType<'WARNING'> = {
  WARNING: [
    'Nemáte oprávnění na přístup k tomuto modulu.',
    SnackbarVariant.WARNING,
  ],
};

export default { ACCESS };
